<svg #graph [style.width.px]="width + margin.left + margin.right" [style.height.px]="height + margin.top + margin.bottom" class="copo-bars-svg">
	<defs>
		<marker id="arrow" viewBox="0 0 20 20" refX="10" refY="10"
			markerWidth="40" markerHeight="20"
			markerUnits="userSpaceOnUse"
			orient="auto-start-reverse">
			<path d="M 2 2 L 10 10 L 2 18" class="copo-bars-arrow"/>
		</marker>
	</defs>
	<ng-container *ngIf="largeScreen else verticalBars">
		<g [attr.transform]="'translate(' + margin.left + ',' + margin.top + ')'">
			<g class="copo-bars-values" *ngIf="x">
				<text *ngFor="let d of barData; let i = index"
					class="copo-bars-value"
					[ngClass]="'bar-data-'+ d.barDataColor"
					(click)="barClick(i, d)"
					[attr.transform]="'translate(' + (barCenter(d.title, x) + 0.5) + ',-20)'"
					text-anchor="middle"
				>
					{{ d.value !== undefined ? (d.value | copoNumber:'number') : 0 }}<tspan class="copo-bars-value-unit"> t</tspan>
				</text>
			</g>
			<g class="copo-bars-container" *ngIf="x && y">
				<path
					*ngFor="let d of barData; let i = index"
					class="copo-bars-bar"
					[ngClass]="'bar-data-'+ d.barDataColor"
					(click)="barClick(i, d)"
					[attr.d]="roundedRect(x(d.title)!, y(d.value !== undefined ? d.value : 0)!, x.bandwidth(), height - y(d.value !== undefined ? d.value : 0)!, 4, true, true, false, false)"
				></path>
			</g>
			<g *ngIf="x" class="copo-bars-bottom-axis" [attr.transform]="'translate(0,' + height + ')'">
				<path class="copo-bars-line" [attr.d]="'M' + x.range()[0] + ',1H' + x.range()[1]" marker-end="url(#arrow)"></path>
				<text
					class="copo-bars-label"
					[ngClass]="'bar-data-'+ d.barDataColor"
					dy="0.71em"
					[attr.transform]="'translate(' + (barCenter(d.title, x) + 0.5) + ', 20)'"
					*ngFor="let d of barData; let i = index"
					(click)="barClick(i, d)"
					[attr.font-weight]="d.bold ? '700' : '300'"
					text-anchor="middle">
					{{ d.title }}
				</text>
			</g>
		</g>
	</ng-container>
	<ng-template #verticalBars>
		<g [attr.transform]="'translate(' + margin.left + ',' + margin.top + ')'">
			<g class="copo-bars-values" *ngIf="yVert">
				<text *ngFor="let d of barData"
					class="copo-bars-value"
					[ngClass]="'bar-data-'+ d.barDataColor"
					dy="-1.2em"
					[attr.transform]="'translate(' + 5  + ',' + (barCenter(d.title, yVert) + 0.5) + ')'"
					text-anchor="left"
				>
					{{ d.value !== undefined ? (d.value | copoNumber:'number') : 0 }}<tspan class="copo-bars-value-unit"> t</tspan>
				</text>
			</g>
			<g class="copo-bars-container" *ngIf="xVert && yVert">
				<path
					*ngFor="let d of barData; let i = index"
					class="copo-bars-bar"
					[ngClass]="'bar-data-'+ d.barDataColor"
					(click)="barClick(i, d)"
					[attr.d]="roundedRect(0, yVert(d.title)! , width- xVert(d.value !== undefined ? d.value : 0)!, yVert.bandwidth(), 4, false, true, false, true)"
				></path>
			</g>
			<g class="copo-bars-bottom-axis" *ngIf="yVert">
				<path class="copo-bars-line" [attr.d]="'M' + yVert.range()[0] + ',1V' + yVert.range()[1]" marker-end="url(#arrow)"></path>
				<text
					class="copo-bars-label"
					[ngClass]="'bar-data-'+ d.barDataColor"
					dy="0.25em"
					[attr.transform]="'translate(-3, ' + (barCenter(d.title, yVert) + 0.5) + ')'"
					*ngFor="let d of barData"
					[attr.font-weight]="d.bold ? '700' : '300'"
					text-anchor="end">
					{{ d.title }}
				</text>
			</g>
		</g>
	</ng-template>
</svg>